import Box from "@/components/Box";
import IconType from "@/components/IconType";
import RichText from "@/components/RichText";
import { useTestProductModalContext } from "@/contexts/TestProductModalContext";
import { useOrganisationBasketContext } from "@/contexts/organisations/OrganisationBasketContext";
import { COMING_SOON, OUT_OF_STOCK } from "@/core/constants";
import { PanelBoxV2 } from "@/tpo/Boxes";
import Spacer from "@/tpo/Spacer";
import Stack from "@/tpo/Stack";
import { useTheme } from "styled-components";

import ReportAddOnDetail from "./ReportAddOnDetail";
import classes from "./RichText.module.scss";

export default function ReportAddons({ description, addons, onRemovingAddon, onAddingOn }) {
  const theme = useTheme();
  const { testProduct } = useTestProductModalContext();
  const { basket, hasBasketGotProduct, hasProductGotAddon } = useOrganisationBasketContext();
  const basketHasGotProduct = hasBasketGotProduct(testProduct.id);

  return (
    <PanelBoxV2
      maxWidth={768}
      outer={{
        bg: "haze",
        pt: theme.spacing.section.pt,
        pb: theme.spacing.section.pb,
        px: [20, 20, 40],
        "data-component-name": "ReportAddons"
      }}
      stacked
      gap={40}
    >
      <RichText
        fontFamily="gilroyMedium"
        fontSize={[14, 14, 16]}
        data-testid="additionalMarkerAddOnsDescription"
        style={{
          whiteSpace: "normal"
        }}
      >
        {description}
      </RichText>
      {basket?.purchaseAsStock || basket?.multiplePatientsEnabled ? (
        <Box color="red" fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          Add-ons unavailable when purchasing products{" "}
          {basket?.purchaseAsStock ? "as stock" : "for multiple patients"}
        </Box>
      ) : (
        <Box
          color="dark"
          fontFamily="gilroyRegular"
          fontSize={[14, 14, 16]}
          fontStyle="italic"
          data-testid="addons-unavailable"
        >
          Add-ons will be unavailable when purchasing products as stock.
        </Box>
      )}
      <Stack gap={16}>
        {addons.map(addon => {
          let state;
          if (basketHasGotProduct && !basket?.purchaseAsStock && !basket?.multiplePatientsEnabled) {
            if (addon.status === OUT_OF_STOCK || addon.status === COMING_SOON) {
              state = "unavailable";
            } else {
              if (hasProductGotAddon(testProduct.id, addon.id)) {
                state = "selected";
              } else {
                state = "unselected";
              }
            }
          } else {
            state = "unavailable";
          }

          return (
            <ReportAddOnDetail
              key={addon.id}
              name={addon.name}
              description={addon.content.description}
              shortDescription={addon.content.shortDescription}
              price={addon.tradeCurrentPrice}
              rrpPrice={addon.exvatFullPrice}
              state={state}
              text={
                addon.status === OUT_OF_STOCK || addon.status === COMING_SOON
                  ? addon.status
                  : undefined
              }
              onRemove={() => onRemovingAddon({ addon })}
              onAdd={() => onAddingOn({ addon })}
              icon={
                <IconType iconType={addon.content.reportIcon} iconSize={[40]} withCircle={false} />
              }
              functionalDatapointCount={addon.functionalDatapointCount}
              dnaDatapointCount={addon.dnaDatapointCount}
              status={addon.status}
              showDescription={addon.status !== COMING_SOON}
              showMarkers={addon.status !== COMING_SOON}
            />
          );
        })}
      </Stack>
    </PanelBoxV2>
  );
}
